export default __webpack_public_path__ + "static/media/sort-down.0d0916eb.svg";